import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'inc-abstract-details',
  template: ''
})
export class AbstractDetailsComponent<T> {
  @Input() inData: T;
  @Output() callMore: EventEmitter<T> = new EventEmitter();

  constructor() { }

  more() {
    this.callMore.emit(this.inData);
  }

}
